import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'HomeView',
    component: HomeView
  },
  {
    path: '/funding',
    name: 'FundingView',
    component: () => import('@/views/FundingView.vue')
  },
  {
    path: '/activities',
    name: 'Activities',
    component: () => import('@/views/ActivitiesView.vue')
  },
  {
    path: '/activities/escape-room',
    name: 'EscapeRoom',
    component: () => import('@/views/activities/EscapeRoomView.vue')
  },
  {
    path: '/activities/open-cinema',
    name: 'OpenCinema',
    component: () => import('@/views/activities/OpenCinemaView.vue')
  },
  {
    path: '/activities/bvumbwe-hike',
    name: 'BvumbweHike',
    component: () => import('@/views/activities/BvumbweHikeView.vue')
  },
  {
    path: '/activities/culinary-experience',
    name: 'CulinaryExperience',
    component: () => import('@/views/activities/CulinaryExperienceView.vue')
  },
  {
    path: '/activities/farmers-market',
    name: 'FarmersMarket',
    component: () => import('@/views/activities/FarmersMarketView.vue')
  },
  {
    path: '/activities/farmers-market/apply',
    name: 'FarmersMarketApply',
    component: () => import('@/views/activities/FarmersMarketApplyView.vue')
  },
  {
    path: '/map',
    name: 'MapView',
    component: () => import('@/views/MapView.vue')
  },
  {
    path: '/moon',
    name: 'MoonView',
    component: () => import('@/views/MoonView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
